import React from "react";
export default function About(props) {
  if (!props.data) return null;

  const bio = props.data.bio;
  const email = props.data.email;
  const phoneNo = props.data.phone;
  const linkedin = props.data.linkedin;
  const github = props.data.github;
  const bitbucket = props.data.bitbucket;

  return (
    <section id="about" className="px-7">
      
      <div className="row">
        <div className="w-full main-col">
          <h2 className="font-geist-black">About Me</h2>
          <p className=" font-geist text-3xl">{bio}</p>
          <div className="w-full flex flex-wrap gap-4 justify-between mb-5">
            <div className="w-full flex flex-row gap-7 font-Oxygenbold">
              <a rel="noreferrer" target="_blank" href={`mailto:${email}`}>
                <div className="flex flex-row gap-3 justify-center items-center">
                  <img
                    src="/images/email.png"
                    className="w-6 h-6"
                    alt="email"
                  />
                  <p className="underline">{email}</p>
                </div>
              </a>
              <a
                href={`https://wa.me/${phoneNo}`}
                rel="noreferrer"
                target="_blank"
              >
                <div className="flex flex-row gap-3 justify-center items-center">
                  <img
                    src="/images/phone.png"
                    className="w-6 h-6"
                    alt="phone"
                  />
                  <p className="underline">+{phoneNo}</p>
                </div>
              </a>
            </div>
            <div>
              <div className="list-inline-item list-social-icons flex flex-row gap-4 mt-4">
                <a target="blank"  href={linkedin}>
                  <span className="fa-stack fa-lg">
                    <i className="fas fa-circle fa-stack-2x"></i>
                    <i className="fab fa-linkedin-in fa-stack-1x fa-inverse"></i>
                  </span>
                </a>
                <a target="blank"  href={github}>
                  <span className="fa-stack fa-lg">
                    <i className="fas fa-circle fa-stack-2x"></i>
                    <i className="fab fa-github-alt fa-stack-1x fa-inverse"></i>
                  </span>
                </a>
                <a target="blank"  href={bitbucket}>
                  <span className="fa-stack fa-lg">
                    <i className="fas fa-circle fa-stack-2x"></i>
                    <i className="fab fa-bitbucket fa-stack-1x fa-inverse"></i>
                  </span>
                </a>
              </div>
            </div>
          </div>
          <div className="row mt-5">
            <div className="columns download">
                <a
                  href="/resume.pdf"
                  rel="noreferrer"
                  target="_blank"
                  download
                  className="button font-geist-bold mr-5"
                >
                  <i className="fa fa-download"></i>Download Resume
                </a>
                <a
                  href="https://generate-ats-cv-4o7d.vercel.app/download-cv"
                  download
                  className="button font-geist-bold"
                  style={{background: "#00C853"}}
                >
                  <i className="fa fa-star"></i>ATS Friendly
                </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
